import React, { useState } from "react";
import "../styles/ContactUs.css";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Add submission logic here
  };

  return (
    <div className="contact-container">
      <div className="contact-content">
        <h1 className="title-cool">Contact us</h1>
        <p style={{ textAlign: "center", maxWidth: "600px" }}>
          Send us a message using the contact form below, and we'll get back to
          you in 24 hours.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              placeholder="Enter your name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="Enter your message"
              value={formData.message}
              onChange={handleChange}
              rows="3"
              required
            />
          </div>

          <button
            type="submit"
            className="primary-button secondary-button"
            style={{ width: "100%" }}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
